import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function TechnicalWorksPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-file-text-line', title: t('servicePages.technical.features.f1.title'), desc: t('servicePages.technical.features.f1.desc') },
    { icon: 'ri-draft-line', title: t('servicePages.technical.features.f2.title'), desc: t('servicePages.technical.features.f2.desc') },
    { icon: 'ri-image-edit-line', title: t('servicePages.technical.features.f3.title'), desc: t('servicePages.technical.features.f3.desc') },
    { icon: 'ri-layout-grid-line', title: t('servicePages.technical.features.f4.title'), desc: t('servicePages.technical.features.f4.desc') },
    { icon: 'ri-printer-line', title: t('servicePages.technical.features.f5.title'), desc: t('servicePages.technical.features.f5.desc') },
    { icon: 'ri-palette-line', title: t('servicePages.technical.features.f6.title'), desc: t('servicePages.technical.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.technical.details.d1.label'),
      title: t('servicePages.technical.details.d1.title'),
      body: t('servicePages.technical.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/2db1d6b80b0412d1daa24815f19bd4ab.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.technical.details.d2.label'),
      title: t('servicePages.technical.details.d2.title'),
      body: t('servicePages.technical.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=modern%20graphic%20design%20studio%20with%20digital%20illustrations%20on%20large%20monitors%2C%20brand%20identity%20materials%2C%20logo%20design%20process%2C%20dark%20themed%20creative%20workspace%20with%20cyan%20and%20white%20color%20palette%2C%20visual%20branding%20assets%20displayed%20on%20screens%2C%20no%20people%2C%20professional%20creative%20environment&width=800&height=500&seq=technical-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-pen-nib-line"
          label={t('servicePages.technical.label')}
          title={t('servicePages.technical.title')}
          subtitle={t('servicePages.technical.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20abstract%20technical%20background%20with%20geometric%20blueprint%20grid%20lines%2C%20engineering%20schematics%20and%20drafting%20patterns%2C%20deep%20graphite%20atmosphere%20with%20glowing%20cyan%20accent%20lines%2C%20professional%20technical%20design%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20lighting%2C%20no%20people&width=1920&height=900&seq=technical-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
